import styled from 'styled-components';

import type { HeaderThemeColor } from '../Header.theme';
import { headerThemes } from '../Header.theme';

interface SubnavProps {
  $headerIsVisible: boolean;
  $isVisible: boolean;
  $localeSwitchBannerIsVisible: boolean;
  $themeColor: HeaderThemeColor;
}

export const Subnav = styled.nav<SubnavProps>`
  display: none;
  @media (${props => props.theme.breakpoint.lg.up}) {
    position: fixed;
    top: ${props => {
      let offset = 0;
      if (props.$headerIsVisible) {
        offset += parseInt(props.theme.headerHeight);
      }
      if (props.$localeSwitchBannerIsVisible) {
        offset += parseInt(props.theme.localeSwitchBannerHeight);
      }
      return offset;
    }}px;
    left: 0;
    z-index: ${props => (props.$isVisible ? 199 : 198)};
    display: block;
    width: 100vw;
    color: ${props => props.theme.color[headerThemes[props.$themeColor].subnav.text]};
    background-color: ${props => props.theme.color[headerThemes[props.$themeColor].subnav.background]};
    transition: top ${props => props.theme.transitionTiming}, transform ${props => props.theme.transitionTiming};
    transition-delay: 0s, ${props => (props.$isVisible ? 0 : 250)}ms;
    transform: translateY(${props => (props.$isVisible ? '0' : '-110%')});
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 94px;
  padding: 16px 0;
`;
